import ApiBase from '@/sag-core/base/ApiBase'
import https from '@/apis/https.js'
import tools from '@/sag-core/tools'
import store from '@/store'

let api = null
api = tools.mergeDeep(new ApiBase(), {
    CompanyLogin: (CompanyCode, PassWord)=>{
        return https({
            method: 'post',
            url: `https://eip2.sag.tw/SAGVueFrameApi/VueFrameAPI/CompanyLogin`,
            data: { 
                CompanyCode
                ,PassWord
            }
        })
    },
    GetCompanyOrder: (CompanyCode)=>{
        return https({
            method: 'post',
            url: `https://eip2.sag.tw/SAGVueFrameApi/Company/GetCompanyOrder`,
            data: { 
                CompanyCode
            }
        })
    }

})

if(store.state.webConfig.apiTest){
    api = tools.mergeDeep(new ApiBase(), {
        CompanyLogin: (CompanyCode, PassWord)=>{
            return https({
                method: 'post',
                url: `http://localhost:12345/VueFrameAPI/CompanyLogin`,
                data: { 
                    CompanyCode
                    , PassWord
                }
            })
        },
        GetCompanyOrder: (CompanyCode)=>{
            return https({
                method: 'post',
                url: `http://localhost:12345/Company/GetCompanyOrder`,
                data: { 
                    CompanyCode
                }
            })
        }
    })
}

export default api